exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".excel-upload-input[data-v-4a89b467]{display:none;z-index:-9999}.drop[data-v-4a89b467]{border:2px dashed #54545c;width:100%;height:260px;line-height:260px;margin:0 auto;font-size:24px;border-radius:5px;text-align:center;color:#54545c;position:flex;justify-content:center;align-items:center}.drop[data-v-4a89b467]:hover{border:2px dashed #d3142c;color:#d3142c}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4a89b467","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/combustibles_Componentes/ImportarTarjetas.vue
// module id = 3463
// module chunks = 0